const SIZE_OPTIONS = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'] as const

export const sizeValidator = () => {
  return (v: (typeof SIZE_OPTIONS)[number]) => SIZE_OPTIONS.includes(v)
}
